module.exports = __webpack_public_path__ + "img/ice-cream-8081692_1280_thumb.70f15c4d.png";